import DomainResource from './DomainResource';
import merge from 'lodash/merge';
import Reference from './types/Reference';

/**
 * Append-only patient financial journal (Package C M1).
 * Field contracts: bestnotes docs/discovery/patient-ledger-data-dictionary.md §4.
 * Signed amounts increase (+), decrease (-), or do not affect (0) patient AR.
 */
export default class BN_PatientLedgerEntry extends DomainResource {
    static __className = 'BN_PatientLedgerEntry';
    static AMOUNT_SIGN_BY_ENTRY_TYPE = Object.freeze({
        charge: 1,
        planned_charge: 0,
        patient_payment: -1,
        failure: 0,
        decline: 0,
        refund: 1,
        payment_reversal: -1,
        void: 1,
        // ERA / Availity (stored amounts are already signed). Charge-post writes `charge` / `planned_charge`.
        insurance_payment: -1,
        write_off: -1,
        patient_responsibility: 0,
        denial: 0,
    });
    static ENTRY_TYPES = Object.freeze(Object.keys(BN_PatientLedgerEntry.AMOUNT_SIGN_BY_ENTRY_TYPE));

    __objectStructure = {
        entryType: String,
        amount: Number,
        amountCents: Number,
        currency: String,
        postedAt: String,
        effectiveDate: String,
        patient: Reference,
        account: Reference,
        sourceSystem: String,
        correlationId: String,
        idempotencyKey: String,
        envelopeId: String,
        description: String,
        rawPayloadUri: String,
        chargeItem: Reference,
        claim: Reference,
        bnEra: Reference,
        bnPayment: Reference,
        reverses: Reference,
        paymentIntentId: String,
        approvalStatus: String,
        approvedBy: String,
        approvedAt: String,
        matchStatus: String,
        proposalId: String,
        processorTxnId: String,
        transactionApiId: String,
        orderNumber: String,
        fortisTransactionAmountRaw: Number,
        fortisSubtotalAmountRaw: Number,
        fortisSurchargeAmountRaw: Number,
        authAmountRaw: Number,
        currencyCode: String,
        statusCode: String,
        status: String,
        reasonCodeId: String,
        reasonCode: String,
        verbiage: String,
        responseMessage: String,
        paymentMethod: String,
        accountType: String,
        entryModeId: String,
        lastFour: String,
        firstSix: String,
        tokenId: String,
        accountVaultId: String,
        authCode: String,
        locationId: String,
        productTransactionId: String,
        previousTransactionId: String,
        isVoidable: Boolean,
        isRefundable: Boolean,
        isSettled: Boolean,
        settleDate: String,
        voidDate: String,
    };

    constructor(constructJson, className = 'BN_PatientLedgerEntry') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
